import React from 'react';
import { NavLink } from 'react-router-dom';

// "People | Roles" under the page title of the Users pages.
const tabClass = ({ isActive }) =>
  `px-4 py-2 -mb-px border-b-2 text-sm font-medium transition-colors ${
    isActive
      ? 'border-blue-600 text-blue-700'
      : 'border-transparent text-gray-500 hover:text-gray-800 hover:border-gray-300'
  }`;

const UsersTabs = () => (
  <nav className="flex gap-2 border-b border-gray-200 mb-6" aria-label="Users and roles">
    <NavLink to="/users" end className={tabClass}>
      People
    </NavLink>
    <NavLink to="/users/roles" className={tabClass}>
      Roles
    </NavLink>
  </nav>
);

export default UsersTabs;
